/**
 * Pure calibration math (unit-tested): userLatencyOffset = median(tap − beat),
 * clamped to ±CALIBRATION_CLAMP_MS (spec 5.4).
 */
import { CALIBRATION_CLAMP_MS } from "../config/tuning";

/** Median of tap-vs-beat differences in ms, clamped. Null if no valid taps. */
export function computeLatencyOffsetMs(diffsMs: number[]): number | null {
  if (diffsMs.length === 0) return null;
  const sorted = [...diffsMs].sort((a, b) => a - b);
  const mid = Math.floor(sorted.length / 2);
  const median =
    sorted.length % 2 === 1 ? sorted[mid]! : (sorted[mid - 1]! + sorted[mid]!) / 2;
  return Math.max(-CALIBRATION_CLAMP_MS, Math.min(CALIBRATION_CLAMP_MS, Math.round(median)));
}

/** Match a tap to the nearest scheduled beat; null if further than maxMs away. */
export function nearestBeatDiffMs(
  tapTimeS: number,
  beatTimesS: number[],
  maxMs: number,
): number | null {
  let best: number | null = null;
  for (const bt of beatTimesS) {
    const diff = (tapTimeS - bt) * 1000;
    if (Math.abs(diff) <= maxMs && (best === null || Math.abs(diff) < Math.abs(best))) {
      best = diff;
    }
  }
  return best;
}
